export default "__VITE_ASSET__Bx1HaE3x__"